<template>
  <div class="enter_form">
    <el-form label-position="top">
      <el-row type="flex" :gutter="48" justify="center">
        <el-col class="block">
          <p class="title">填写基本信息</p>
          <el-form-item label="店铺绑定手机号" required>
            <el-input placeholder="店铺绑定手机即为店铺的登录账号名" v-model="a"></el-input>
          </el-form-item>
          <el-form-item label="店铺名称" required>
            <el-input placeholder="3到20字，不可包含空格"></el-input>
          </el-form-item>
          <el-form-item label="服务费比例" required>
            <el-input placeholder="密码6-32位，由数字、字母、特殊字符至少两种组成"></el-input>
          </el-form-item>
          <el-form-item label="联系人" required>
            <el-input placeholder="请填写店铺联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" required>
            <el-input placeholder="请填写店铺联系电话"></el-input>
          </el-form-item>
        </el-col>
        <el-col class="block">
          <p class="title">填写店铺信息</p>
          <el-form-item required>
            <span slot="label">
              <span>经营范围</span>
              <span class="suffix">提交后不可修改</span>
            </span>
            <el-row type="flex" :gutter="20" justify="space-between">
              <el-col>
                <el-select v-model="value" clearable placeholder="一级分类">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col>
                <el-select v-model="value" clearable placeholder="二级分类">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="客服电话" required>
            <el-input placeholder="座机、手机等"></el-input>
          </el-form-item>
          <el-form-item label="店铺营业时间" required>
            <el-row type="flex" justify="space-between">
              <el-col>
                <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
              </el-col>
              <el-col class="middle">
                <span>至</span>
              </el-col>
              <el-col>
                <el-date-picker v-model="value" type="date" placeholder="选择日期"></el-date-picker>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="店铺地址所在区">
            <el-row type="flex" :gutter="20" justify="space-between">
              <el-col>
                <el-select v-model="value" clearable placeholder="选择省">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col>
                <el-select v-model="value" clearable placeholder="选择市">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
              <el-col>
                <el-select v-model="value" clearable placeholder="选择区">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="店铺详细地址">
            <el-input placeholder="如：xx街道xx楼xx号"></el-input>
          </el-form-item>
          <el-form-item label="经纬度">
            <el-row type="flex" :gutter="20" justify="space-between">
              <el-col>
                <el-input v-model="form.offshop.longitude" disabled></el-input>
              </el-col>
              <el-col>
                <el-input v-model="form.offshop.latitude" disabled></el-input>
              </el-col>
              <el-col class="location">
                <i class="el-icon-map-location" @click="select"></i>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="主营产品" required>
            <el-input type="textarea" rows="3" placeholder="请用3-200字罗列主营产品"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" :gutter="37" justify="center" class="btn-submit">
        <el-col>
          <el-button @click="prev" type="danger">上一步，选择店铺类型</el-button>
        </el-col>
        <el-col>
          <el-button @click="next" type="info">下一步，上传店铺资质</el-button>
        </el-col>
      </el-row>
    </el-form>

    <!-- 地址选择 -->
    <el-dialog title="请选择地址" :visible.sync="dialogVisible" @opened="createMap">
      <div class="map">
        <div class="mapTip">
          <el-input
            id="map-search"
            v-model="mapSearch"
            placeholder="请输入地址"
            autocomplete="off"
            @focus="mapSearch=''"
          ></el-input>
          <!-- <el-button type="danger">搜索</el-button> -->
        </div>
        <div id="mapDiv"></div>
      </div>
      <div class="footer">
        <el-button @click="cancel">取消</el-button>
        <el-button class="commit" @click="commit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  model: {
    prop: "form"
  },
  props: {
    form: Object
  },
  data() {
    return {
      dialogVisible: false,
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      mapSearch: "",
      lnglat: {},
      a:''
    };
  },
  methods: {
    prev() {
      this.form.step = 1;
      this.$emit("update:form", this.form);
    },
    next() {
      this.form.step = 3;
      this.$emit("update:form", this.form);
    },
    // 选择地址
    select() {
      this.lnglat = {};
      this.mapSearch = "";
      this.dialogVisible = true;
    },
    // 生成地图
    createMap() {
      let center;
      // 调用高德 api 绘制底图以及获取 geo 数据
      if (this.form.offshop.longitude && this.form.offshop.latitude) {
        center = [this.form.offshop.longitude, this.form.offshop.latitude];
      }
      let map = new AMap.Map("mapDiv", {
        zoom: 14,
        center: center || [116.397221, 39.908882]
      });
      center &&
        new AMap.Marker({
          map: map,
          icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          position: center
        });
      map.on("click", e => {
        console.log("select-->", e.lnglat.lng, e.lnglat.lat);
        this.lnglat = e.lnglat;
        map.clearMap();
        new AMap.Marker({
          map: map,
          icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
          position: [e.lnglat.lng, e.lnglat.lat]
        });
      });
      AMap.plugin(["AMap.Autocomplete", "AMap.PlaceSearch"], () => {
        var autoOptions = {
          input: "map-search"
        };
        var placeSearch = new AMap.PlaceSearch({
          map: map
        });
        var autocomplete = new AMap.Autocomplete(autoOptions);
        AMap.event.addListener(autocomplete, "select", e => {
          console.log(e);
          if (e.poi.location) {
            let location = [e.poi.location.lng, e.poi.location.lat];
            map.clearMap();
            new AMap.Marker({
              map: map,
              icon: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
              position: location
            });
            map.setCenter(location);
            this.lnglat = {
              lng: location[0],
              lat: location[1]
            };
          } else {
            placeSearch.search(e.poi.name);
          }
        });
      });
    },
    // 地址确认选择
    commit() {
      if (this.lnglat.lng && this.lnglat.lat) {
        this.form.offshop.longitude = this.lnglat.lng;
        this.form.offshop.latitude = this.lnglat.lat;
      }
      this.cancel();
    },
    // 地址取消选择
    cancel() {
      this.dialogVisible = false;
    }
  }
};
</script>
<style lang="less" scoped>
.enter_form {
  width: 882px;

  /deep/ .block {
    width: 417px;

    .title {
      color: #333;
      font-size: 20px;
      margin-bottom: 5px;
    }
  }
  .el-form {
    .el-form-item {
      .el-form-item__label {
        .suffix {
          color: #e60616;
          font-size: 14px;
        }
      }
      .middle {
        width: auto;
        padding: 0 15px !important;
        display: flex;

        span {
          margin: auto;
        }
      }
      .location {
        width: 40px;
        padding: 0 !important;
        display: flex;

        i {
          display: inline-block;
          width: 40px;
          margin: auto;
          font-size: 20px;
          cursor: pointer;
        }
      }
    }
  }
  .btn-submit {
    margin-top: 14px;

    .el-col {
      width: 350px;
    }
    /deep/ .el-button--danger {
      background-color: #fff;
      border-color: #eb1b29;
      span {
        color: #eb1b29;
      }
    }
    /deep/ .el-button--info {
      background-color: #d9d9d9;
      border: none;
    }
  }

  // 地图选择弹出框
  /deep/ .el-dialog {
    width: 882px;
    &__close {
      font-size: 25px;
    }
    &__body {
      padding: 0;
    }
    .map {
      position: relative;

      .mapTip {
        position: absolute;
        top: 24px;
        left: 36px;
        z-index: 9999999999;

        .el-input {
          width: 352px;
          height: 44px;

          &__inner {
            border-radius: 0;

            &:focus {
              border-color: #e60616;
            }
          }
        }
        .el-button {
          width: 77px;
          height: 42px;
          margin-left: 20px;
        }
      }
      #mapDiv {
        width: 882px;
        height: 450px;
      }
    }
    .footer {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding: 36px;
      background-color: #fff;

      .el-button {
        width: 124px;
        height: 48px;
        border-radius: 0;

        &.commit {
          margin-left: 24px;
          border-color: #e60616;
          color: #e60616;
        }
      }
    }
  }
}
</style>